// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__1cuTE","rowsWrapper":"style_rowsWrapper__WlQTa","rowWrapper":"style_rowWrapper__3EwTB"};